<div class="timeentries-content">
  <!-- Apontamento Ativo -->
  @if (activeEntry; as entry) {
    <div class="active-time-entry-card">
      <div class="active-time-entry-header">
        <i class="pi pi-clock"></i>
        <span>Apontamento em Andamento</span>
      </div>
      <div class="active-time-entry-details">
        <div class="detail-row">
          <span class="label">Descrição:</span>
          <div class="value">
            <markdown [data]="entry.description || ''"></markdown>
          </div>
        </div>
        <div class="detail-row">
          <span class="label">Início:</span>
          <span class="value">{{ formatDate(entry.start_date || '') }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Tipo:</span>
          <span class="value">{{ entry.type }}</span>
        </div>
      </div>
      <div class="active-time-entry-actions">
        <!-- Em readOnly o botão fica desabilitado, não escondido: a ação existe, só não é aqui.
             Esconder faria parecer que este chamado não tem como encerrar apontamento. -->
        <p-button
          icon="pi pi-stop"
          label="Encerrar Apontamento"
          severity="danger"
          size="small"
          [disabled]="readOnly"
          [pTooltip]="readOnly ? 'Encerre o apontamento pela tela do chamado' : ''"
          tooltipPosition="top"
          (onClick)="stopRequested.emit()" />
      </div>
    </div>
  }

  <!-- Listagem de Apontamentos -->
  <div class="timeentries-list">
    <div class="list-header">
      <h4>Histórico Completo</h4>
    </div>

    @if (entries.length > 0) {
      <div class="timeentries-grid">
        @for (entry of entries; track entry.id) {
          <div class="timeentry-card" [class.active]="!entry.end_date">
            <div class="entry-header">
              <span class="entry-type">{{ getTypeLabel(entry.type) }}</span>
              <span class="entry-date">{{ formatDate(entry.start_date || '') }}</span>
            </div>
            <div class="entry-description">
              <markdown [data]="entry.description || 'Sem descrição'"></markdown>
            </div>

            <!-- Informações adicionais -->
            <div class="entry-details">
              <div class="detail-row">
                <span class="detail-label">Usuário:</span>
                <span class="detail-value">{{ entry.user?.name || 'Não informado' }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Atendimento:</span>
                <span class="detail-value">{{ getAttendanceLabel(entry.attendance_type) }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Departamento:</span>
                <span class="detail-value">{{ getDepartmentLabel(entry.department_type) }}</span>
              </div>
              @if (entry.task?.description) {
                <div class="detail-row">
                  <span class="detail-label">Tarefa:</span>
                  <span class="detail-value">{{ entry.task?.description || '' }}</span>
                </div>
              }
              @if (entry.end_date) {
                <div class="detail-row">
                  <span class="detail-label">Término:</span>
                  <span class="detail-value">{{ formatDate(entry.end_date) }}</span>
                </div>
              }
            </div>

            <div class="entry-footer">
              <span class="entry-duration">{{ calculateDurationLog(entry) }}</span>
              @if (!entry.end_date) {
                <span class="active-indicator">Ativo</span>
              }
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="empty-state">
        <i class="pi pi-clock"></i>
        <p>Nenhum apontamento encontrado</p>
      </div>
    }
  </div>
</div>
